import { BiteData } from "../../types/data";
import { getBiteStyle, resolveDisplayState } from "../../types/utils";
import { displayStateMetadata } from "../../constants/config/support";

// A tile that triggers a popover leaves the details to it: a native title
// would show on top of the popover.
const Bite = ({
  bite,
  showTitle = true,
}: {
  bite: BiteData;
  showTitle?: boolean;
}) => {
  const state = resolveDisplayState(bite);
  const { backgroundColor, border } = getBiteStyle(bite);

  return (
    <div
      className={`p-2 rounded-md w-full h-full ${backgroundColor} ${border}`}
      title={
        showTitle
          ? `${displayStateMetadata[state].label}${bite.isLastLearned ? " · Last learned" : ""}${bite.attempts.length > 1 ? ` · ${bite.attempts.length} attempts` : ""}`
          : undefined
      }
    >
      <span className="et-bite-index">{bite.biteIndex}</span>
    </div>
  );
};

export default Bite;
